import { Box } from "@mui/material";
import Footer from "components/Footer";
import PageDefaultLayout from "components/LayoutContainers/PageDefaultLayout/pageDefaultLayout";
import { setAnotherPage } from "context";
import { useMaterialUIController } from "context";
import { useEffect } from "react";
import CarouselSlide from "../../components/CarouselSlide/CarouselSlide";
import NewsList from "components/NewsList/newsList";

const Home = () => {
  const [controller, dispatch] = useMaterialUIController();
  useEffect(() => {
    setAnotherPage(dispatch, true);
  }, []);
  return (
    <PageDefaultLayout>
      <Box>
        <CarouselSlide />
      </Box>
      <NewsList />
      <Footer isNotAbsolute={false} />
    </PageDefaultLayout>
  );
};

export default Home;
